import SearchIcon from '@mui/icons-material/Search';
import styles from './search-bar.module.scss';
import { useState } from 'react';
import SearchModal from '../search-modal/search-modal';
import Button from 'components/atoms/button/button';

function SearchBar() {
  const [open, setOpen] = useState<boolean>(false);

  const handleClick = () => {
    setOpen(true);
  };

  return (
    <>
      <Button type="base" onClick={handleClick} className={styles.container}>
        <>
          <SearchIcon style={{color:"var(--color-white)"}} fontSize="small" />
          <span style={{color:"var(--color-white)"}}>Search</span>
        </>
      </Button>
      <SearchModal open={open} setOpen={setOpen} />
    </>
  );
}

export default SearchBar;
